import React, { useState, useEffect } from "react";
import {
    AppBar,
    CircularProgress,
    Divider,
    Grid,
    IconButton,
    Toolbar,
    Typography,
} from "@mui/material/";
import { Menu, Close } from "@mui/icons-material";
import { useSelector } from "react-redux";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import makeStyles from "@mui/styles/makeStyles";
import Drawer from "../../common/components/Drawer";
import styles from "./menuStyles";
import { useTranslation } from "react-i18next";
import menuUtils from "./menuUtils";
import useMenuItems from "./useMenuItems";
import { useBranding } from "../../common/hooks";
import { LoginLogo } from "../../common/components";

/**
 * App UserMenu Component
 *
 */

export default () => {
    const [logo, setLogo] = useState("");
    const { audits, organisation } = useSelector((state) => state);
    const { headerLogo, name } = useBranding();
    const classes = makeStyles(styles)();
    const { t } = useTranslation();
    const location = useLocation();
    const navigate = useNavigate();
    const { auditId } = useParams();
    const { pathname } = location;
    const [open, setOpen] = useState(false);
    const pathHasNumbers = menuUtils.containsNumbers(pathname);
    const title = menuUtils.screenTitle(pathname);
    const items = useMenuItems(title);
    const isOrgLoaded =
        organisation && Object.keys(organisation).length > 0 ? true : false;

    useEffect(() => {
        setLogo(headerLogo);
        return () => {
            setOpen(false);
        };
    }, [logo, name]);

    const toggleDrawer = () => {
        setOpen(!open);
    };

    const handleDrawerClose = () => {
        setOpen(false);
    };

    const onBack = () => {
        handleDrawerClose();
        if (title === "audits/assets/list") {
            let url;
            if (
                audits.item &&
                audits.item.auditReference.toLowerCase() !== "none"
            )
                url = `/auth/audits/${auditId}/groupedAudits`;
            else url = `/auth/audits/${auditId}/details`;
            navigate(url);
        } else if (
            title === `audits/details` ||
            title === `audits/groupedAudits`
        ) {
            navigate(`/auth/audits/list`);
        } else navigate(-1);
    };

    return (
        <>
            <AppBar className={classes.appBar} elevation={0}>
                <Toolbar className={classes.toolbar}>
                    <Grid container>
                        <Grid item xs={3} className={classes.menuLeftContainer}>
                            {pathHasNumbers === true ? (
                                <>
                                    <IconButton onClick={onBack}>
                                        <ArrowBackIcon color="white" />
                                    </IconButton>
                                </>
                            ) : (
                                <>
                                    {isOrgLoaded ? (
                                        <Typography
                                            component="div"
                                            src={headerLogo}
                                            alt={name}
                                            className={classes.logoContent}
                                        >
                                            <LoginLogo
                                                height={50}
                                                light
                                                url={headerLogo}
                                            />
                                        </Typography>
                                    ) : (
                                        <CircularProgress
                                            color="secondary"
                                            size={24}
                                        />
                                    )}
                                </>
                            )}
                        </Grid>
                        <Grid item xs={6} className={classes.titleText}>
                            {pathHasNumbers === true ? (
                                <Typography component="h5">
                                    {t(`titles.${title}`)}
                                </Typography>
                            ) : null}
                        </Grid>
                        <Grid item xs={3}>
                            <IconButton
                                className={classes.iconButton}
                                onClick={toggleDrawer}
                                size="large"
                            >
                                {!open ? <Menu /> : <Close />}
                            </IconButton>
                        </Grid>
                    </Grid>
                </Toolbar>
                <Divider />
            </AppBar>
            <Drawer
                disabled={true}
                items={items}
                onClose={handleDrawerClose}
                open={open}
            />
        </>
    );
};
